import * as React from 'react'

const SvgAddFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 1.25c-4.75 0-8.75 4-8.75 8.75s4 8.75 8.75 8.75 8.75-4 8.75-8.75-4-8.75-8.75-8.75zm3.75 9.375h-3.125v3.125h-1.25v-3.125H6.25v-1.25h3.125V6.25h1.25v3.125h3.125v1.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgAddFilledIcon
